module.exports = __webpack_public_path__ + "img/智慧警务-移动警务助手软件（安卓版）V2.0.e452b73b.jpg";